import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Tag } from 'primeng/tag';
import type { SpendingLinkedSection } from '../account-detail.model';
import { statusTagSeverity } from '../accounts-display';

@Component({
  selector: 'bn-linked-accounts-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Tag],
  template: `
    @if (section().show) {
      <section class="bn-linked" data-testid="spending-linked">
        <p class="bn-linked__label">Linked external accounts</p>
        @if (section().empty) {
          <p class="bn-linked__empty">No external accounts linked.</p>
        } @else {
          <ul class="bn-linked__list">
            @for (account of section().items; track account.last4Label + account.name) {
              <li class="bn-linked__item">
                <p-tag
                  [value]="account.chipLabel"
                  [severity]="statusSeverity(account.chipLabel)"
                  [rounded]="true"
                  styleClass="bn-accounts-status"
                />
                <span class="bn-linked__name">{{ account.name }}</span>
                <span class="bn-linked__last4">{{ account.last4Label }}</span>
              </li>
            }
          </ul>
        }
      </section>
    }
  `,
  styles: `
    .bn-linked {
      min-width: 0;
      max-width: 28rem;
    }

    .bn-linked__label {
      margin: 0 0 0.55rem;
      font-size: 0.6875rem;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: var(--p-text-muted-color);
    }

    .bn-linked__list {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 0.65rem;
    }

    .bn-linked__item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 0.65rem;
      width: fit-content;
      max-width: 100%;
      font-size: 0.875rem;
    }

    .bn-linked__name {
      min-width: 0;
      font-weight: 600;
      color: var(--p-primary-900, var(--p-text-color));
    }

    .bn-linked__last4,
    .bn-linked__empty {
      color: var(--p-text-muted-color);
    }

    .bn-linked__empty {
      margin: 0;
      font-size: 0.875rem;
    }
  `,
})
export class LinkedAccountsListComponent {
  readonly section = input.required<SpendingLinkedSection>();
  readonly statusSeverity = statusTagSeverity;
}
